const isSafari = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return (
    (ua.includes('Safari') && !ua.includes('Chrome')) ||
    typeof (navigator as { standalone?: boolean }).standalone !== 'undefined'
  );
};

export default isSafari;
